/**
 * Smart tooltip positioner for Highcharts
 * Prevents tooltip from overlapping with legend and keeps it within chart bounds
 *
 * @param {number} labelWidth - Width of the tooltip
 * @param {number} labelHeight - Height of the tooltip
 * @param {object} point - Point object with plotX and plotY
 * @param {object} chart - Highcharts chart instance (this.chart)
 * @returns {object} Position object with x and y coordinates
 */
export default function chartTooltipPositioner(labelWidth, labelHeight, point, chart) {
  const { plotLeft, plotTop, plotHeight, plotWidth, legend } = chart;

  // Ensure tooltip width doesn't exceed chart width to prevent clipping
  const maxWidth = plotWidth;
  const effectiveWidth = Math.min(labelWidth, maxWidth);

  // Default position: centered above the point
  let x = point.plotX + plotLeft - effectiveWidth / 2;
  let y = point.plotY + plotTop - labelHeight - 10;

  // Keep tooltip within horizontal chart bounds
  if (x < plotLeft) {
    x = plotLeft;
  }
  if (x + effectiveWidth > plotLeft + plotWidth) {
    x = plotLeft + plotWidth - effectiveWidth;
  }

  // Prevent overlap with legend - get actual legend position
  const legendTop = legend && legend.group ? legend.group.translateY : plotTop + plotHeight + 20;
  const maxTooltipBottom = legendTop - 30;

  // If tooltip goes above chart, position it below the point
  if (y < plotTop) {
    y = point.plotY + plotTop + 10;
  }

  // If tooltip overlaps with legend, clamp it to stay above legend
  if (y + labelHeight > maxTooltipBottom) {
    y = Math.max(plotTop, maxTooltipBottom - labelHeight);
  }

  return { x, y };
}
